import _ from 'lodash'

export default (options) => (
  _.map(options, ({
    id,
    name,
  }) => ({
    id,
    name,
  }))
)
